import './studioItem.scss';
import React from 'react';
import avatarDefault from '@/images/studio/avatar_default.png';
import { useHistory } from 'react-router';

const statusMap = new Map([
  ['0', { text: '未直播', className: 'will' }],
  ['1', { text: '直播中...', className: 'ing' }],
]);

export function MyStudioItem(props) {
  const { status, avatar, name, subTitle, tag, link } = props;

  const history = useHistory();

  return (
    <div className="myStudioItem" onClick={() => history.push(link)}>
      {status && (
        <div className={`studioStatus ${statusMap.get(status).className}`}>
          {statusMap.get(status).text}
        </div>
      )}
      <div className="avatar">
        <img src={avatar || avatarDefault} alt="" />
      </div>
      <div className="name textOverflow">{name || '暂无'}</div>
      {subTitle && <div className="subTitle textOverflow">{subTitle}</div>}
      {tag && (
        <div className="tag">
          {tag.map((item) => (
            <div className="tag-view" key={Math.random()}>
              <div className="tag-value textOverflow">{item.value}</div>
              <div className="tag-title">{item.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function OtherStudioItem(props) {
  const { status, avatar, name, subTitle, tag, link } = props;

  const history = useHistory();

  return (
    <div className="otherStudioItem" onClick={() => history.push(link)}>
      {status && (
        <div className={`studioStatus ${statusMap.get(status).className}`}>
          {statusMap.get(status).text}
        </div>
      )}
      <div className="avatar">
        <img src={avatar || avatarDefault} alt="" />
      </div>
      <div className="right">
        <div className="name textOverflow">{name || '暂无'}</div>
        {subTitle && <div className="subTitle textOverflow">{subTitle}</div>}
      </div>
      {tag && (
        <div className="tag">
          {tag.map((item) => (
            <div className="tag-view" key={Math.random()}>
              <div className="tag-value textOverflow">{item.value}</div>
              <div className="tag-title">{item.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
